import { useState } from 'react';

import { Tabs } from 'antd';
import { TCustomer } from 'types/customer';

import { CustomerPickerList } from '../customerPickerList';
import { CreateCustomer } from './createCustomer';

const CUSTOMER_LIST_TAB = '1';
const CALLS_TAB = '2';
const CUSTOMER_CREATION_TAB = '3';

type TProps = {
    /** Клиент, у которого галочка горит выбранной */
    selectedCustomerId?: number | null;
    /** Выбор клиента — галочкой в карточке или созданием нового */
    onSelect: (customer: TCustomer) => void;
    /** Запрос из поля поиска в шапке модалки */
    searchQuery: string;
    /** id контейнера прокрутки списка */
    listId: string;
    /** Работа владельца поверх списка — например создание профиля клиента */
    isBusy?: boolean;
};

/**
 * Выбор клиента: список CRM, звонки и создание нового клиента.
 *
 * Общий для создания заказа и смены клиента в заказе — выбор там одинаковый,
 * различается только то, куда модалка ведёт после него.
 */
export const CustomerPickerTabs = ({
    selectedCustomerId,
    onSelect,
    searchQuery,
    listId,
    isBusy = false,
}: TProps) => {
    const [activeKey, setActiveKey] = useState(CUSTOMER_LIST_TAB);

    const handleCustomerCreate = (customer: TCustomer) => {
        // созданный клиент сразу становится выбранным, вкладку возвращаем к списку
        setActiveKey(CUSTOMER_LIST_TAB);
        onSelect(customer);
    };

    return (
        <Tabs
            activeKey={activeKey}
            onChange={setActiveKey}
            centered
            items={[
                {
                    key: CUSTOMER_LIST_TAB,
                    label: 'Клиенты',
                    children: (
                        <CustomerPickerList
                            listId={listId}
                            searchQuery={searchQuery}
                            selectedCustomerId={selectedCustomerId}
                            onSelect={onSelect}
                            isBusy={isBusy}
                        />
                    ),
                },
                {
                    key: CALLS_TAB,
                    label: 'Звонки',
                    children: 'Список звонков пуст',
                    disabled: true,
                },
                {
                    key: CUSTOMER_CREATION_TAB,
                    label: 'Новый клиент',
                    children: <CreateCustomer afterCustomerCreate={handleCustomerCreate} />,
                },
            ]}
        />
    );
};
